export type SkillDTOV2 = {
  active: boolean
  code: string
  default: boolean
  scheduleCode: string
  spaceCode: UUID
  copyCustomFieldsFromParent: boolean
  attachmentsAllowed?: boolean
  groupName?: string
  targetProcessingTime?: number
  validationAllowed?: boolean
}

export enum SkillsIncludeEnum {
  PRODUCTIVITY = 'PRODUCTIVITY',
}

export interface SkillParamsDTOV2 {
  'include-deactivated': boolean
}
